import React from 'react';
import { LockIcon, ShieldCheckIcon, DownloadIcon, UserCheckIcon, HeadphonesIcon } from 'lucide-react';
export const TrustBar: React.FC = () => {
  const trustItems = [{
    icon: <LockIcon className="w-6 h-6 text-blue-600" data-id="element-283" />,
    title: 'Pago Seguro',
    desc: 'Encriptación SSL 256-bit'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-blue-600" data-id="element-284" />,
    title: 'Garantía 100%',
    desc: '45 días de prueba'
  }, {
    icon: <DownloadIcon className="w-6 h-6 text-blue-600" data-id="element-285" />,
    title: 'Acceso Inmediato',
    desc: 'Descarga instantánea'
  }, {
    icon: <UserCheckIcon className="w-6 h-6 text-blue-600" data-id="element-286" />,
    title: 'Privacidad Protegida',
    desc: 'Datos personales seguros'
  }, {
    icon: <HeadphonesIcon className="w-6 h-6 text-blue-600" data-id="element-287" />,
    title: 'Soporte Dedicado',
    desc: 'Asistencia vía email'
  }];
  return <section className="py-12 bg-white border-y border-gray-200" data-id="element-288">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-289">
        <div className="text-center mb-10" data-id="element-290">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-291">
            <LockIcon className="w-6 h-6 text-green-600" data-id="element-292" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-293">
              Transacción Segura al 100%
            </h2>
          </div>
          <p className="text-gray-500" data-id="element-294">
            Tu compra está protegida por los más altos estándares de seguridad
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-10" data-id="element-295">
          {trustItems.map((item, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-296">
              <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center mb-3" data-id="element-297">
                {item.icon}
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-1" data-id="element-298">
                {item.title}
              </h3>
              <p className="text-xs text-gray-500" data-id="element-299">{item.desc}</p>
            </div>)}
        </div>

        <div className="border-t border-gray-100 pt-8 flex justify-center gap-4 flex-wrap" data-id="element-300">
          <div className="px-4 py-2 bg-blue-900 text-white text-sm font-bold rounded" data-id="element-301">
            VISA
          </div>
          <div className="px-4 py-2 bg-gradient-to-r from-red-500 to-orange-500 text-white text-sm font-bold rounded" data-id="element-302">
            MASTERCARD
          </div>
          <div className="px-4 py-2 bg-blue-500 text-white text-sm font-bold rounded italic" data-id="element-303">
            PayPal
          </div>
          <div className="px-4 py-2 bg-blue-400 text-white text-sm font-bold rounded" data-id="element-304">
            AMEX
          </div>
          <div className="px-4 py-2 bg-black text-white text-sm font-bold rounded" data-id="element-305">
            Apple Pay
          </div>
        </div>
      </div>
    </section>;
};